'use client';

import type { ReactNode } from 'react';

/** Sticky uppercase header shared by every result column. */
export function ResultColumnHeader({
  title,
  count,
  action,
}: {
  title: ReactNode;
  count?: number;
  action?: ReactNode;
}) {
  return (
    <div className="text-caption sticky top-0 z-10 flex items-center justify-between border-b border-slate-100/50 bg-slate-50/50 px-5 py-3 font-bold tracking-wider text-slate-400 uppercase backdrop-blur-sm">
      <span className="truncate pr-2">{title}</span>
      <div className="flex shrink-0 items-center gap-2">
        {action}
        {count !== undefined && (
          <span className="text-caption font-normal text-slate-400">
            ({count})
          </span>
        )}
      </div>
    </div>
  );
}

/** Muted empty-state row used when a column has no matches. */
export function ResultColumnEmpty({ children }: { children: ReactNode }) {
  return (
    <div className="text-caption px-5 py-4 text-slate-400 italic">
      {children}
    </div>
  );
}

const baseRowClass =
  'w-full text-left px-5 py-3 transition-colors rounded-lg text-body-lg';

/** Shared class for result rows, highlighted when active/hovered. */
export function resultRowClassName(isActive: boolean): string {
  return `${baseRowClass} ${isActive ? 'bg-slate-100' : 'hover:bg-slate-50'}`;
}
